import { getPartnerById, resolvePartner, type PartnerConfig } from "../config";

// Resolved once at module load. Per-request HTTP code (api/transport.ts,
// utils/api.ts) reads this stable constant instead of touching window on
// every call. Partner identity is hostname-driven and immutable within a
// session, so a one-shot cache is the right shape.
//
// SSR/Node fallback: if window is unavailable, fall back to the default
// partner via getPartnerById — keeps module-load safe in non-browser
// environments (Jest jsdom is fine; pure-node tests would otherwise crash).
const cached: PartnerConfig = (() => {
  try {
    return resolvePartner(window.location.hostname);
  } catch {
    return getPartnerById("sabo");
  }
})();

export const currentPartner = cached;
